import React from 'react';
import { Link } from 'react-router-dom';
import { useAnalyticsConsent } from '../../contexts/AnalyticsConsentContext';

const AnalyticsConsentBanner: React.FC = () => {
  const {
    closeConsentPrompt,
    consentStatus,
    isConsentPromptOpen,
    setConsent
  } = useAnalyticsConsent();

  if (!isConsentPromptOpen) {
    return null;
  }

  const isUpdatingExistingChoice = consentStatus !== 'unknown';

  return (
    <div className="fixed inset-x-0 bottom-0 z-[140] border-t border-red-500/30 bg-gray-950/95 shadow-2xl backdrop-blur">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-4 sm:px-6 lg:flex-row lg:items-end lg:justify-between lg:px-8">
        <div className="max-w-3xl space-y-2">
          <p className="text-sm font-semibold uppercase tracking-[0.24em] text-red-300">
            Cookie Settings
          </p>
          <p className="text-sm leading-relaxed text-slate-200">
            We use optional analytics cookies to understand how the site is used and improve
            performance. These cookies stay off until you choose to allow them.
          </p>
          <p className="text-xs leading-relaxed text-slate-400">
            Read more in our{' '}
            <Link
              to="/privacy"
              className="text-red-300 hover:text-red-200 underline underline-offset-4"
            >
              Privacy Policy
            </Link>
            .
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-3">
          {isUpdatingExistingChoice ? (
            <button
              type="button"
              onClick={closeConsentPrompt}
              className="inline-flex min-h-[44px] items-center justify-center rounded-full border border-gray-700 px-4 text-sm font-medium text-slate-200 transition hover:border-gray-500 hover:text-white"
            >
              Keep current choice
            </button>
          ) : null}
          <button
            type="button"
            onClick={() => setConsent(false)}
            className="inline-flex min-h-[44px] items-center justify-center rounded-full border border-gray-600 px-5 text-sm font-medium text-slate-100 transition hover:border-gray-400 hover:text-white"
          >
            Reject analytics
          </button>
          <button
            type="button"
            onClick={() => setConsent(true)}
            className="inline-flex min-h-[44px] items-center justify-center rounded-full bg-red-500 px-5 text-sm font-semibold text-white transition hover:bg-red-400"
          >
            Accept analytics
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsConsentBanner;
